const CUSTOMER_CATEGORY_TABLE_SELECTION_SESSION_KEY =
  "management.customerCategories.tableSelection";

const ROWS_PER_PAGE_OPTIONS = new Set([25, 50, 100, 250]);

export interface CustomerCategoryTableSelection {
  customerId: number | null;
  rowsPerPage: number;
}

export const isCustomerCategoryRowsPerPage = (value: number): boolean =>
  ROWS_PER_PAGE_OPTIONS.has(value);

export const readCustomerCategoryTableSelection = (): CustomerCategoryTableSelection | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.sessionStorage.getItem(CUSTOMER_CATEGORY_TABLE_SELECTION_SESSION_KEY);
    if (!raw) {
      return null;
    }

    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== "object" || parsed === null) {
      return null;
    }

    const selection = parsed as Record<string, unknown>;
    const customerId = selection.customerId;
    const rowsPerPage = selection.rowsPerPage;

    if (
      (customerId !== null &&
        (typeof customerId !== "number" || !Number.isInteger(customerId) || customerId < 1)) ||
      typeof rowsPerPage !== "number" ||
      !isCustomerCategoryRowsPerPage(rowsPerPage)
    ) {
      return null;
    }

    return { customerId, rowsPerPage };
  } catch {
    return null;
  }
};

export const writeCustomerCategoryTableSelection = (selection: CustomerCategoryTableSelection) => {
  if (typeof window === "undefined" || !isCustomerCategoryRowsPerPage(selection.rowsPerPage)) {
    return;
  }

  try {
    const serialized = JSON.stringify(selection);
    if (
      window.sessionStorage.getItem(CUSTOMER_CATEGORY_TABLE_SELECTION_SESSION_KEY) !== serialized
    ) {
      window.sessionStorage.setItem(CUSTOMER_CATEGORY_TABLE_SELECTION_SESSION_KEY, serialized);
    }
  } catch {
    // Storage can be unavailable; the pages continue with their local selection.
  }
};
